var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreferredDisabled = function SvgPreferredDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 6.688c0-.725-.418-1.385-1.058-1.678L12.72 2.158a1.72 1.72 0 0 0-1.44 0L5.058 5.01A1.85 1.85 0 0 0 4 6.688v4.31C4 16.085 7.413 20.844 12 22c4.587-1.155 8-5.914 8-11.003zm-8-2.853-6.22 2.85-.001.003-.001.001v4.308c0 4.155 2.704 7.982 6.222 9.101 3.518-1.12 6.222-4.946 6.222-9.1v-4.31l-.003-.003z",
    clipRule: "evenodd"
  })));
};
export default SvgPreferredDisabled;